var $ = require('jquery')
  , ERROR_MSG = '网络发生了错误'
  , openAlert = require('game-info/widgets/openAlert')
  , EngageForm = require('game-info/widgets/EngageForm')
  , ajaxEngageCurrentGame = require('apis/ajaxEngageCurrentGame')

var isAjaxing = false;

module.exports = function(e) {
  var ued = window.ued || {}
    , element = $(e.currentTarget)
    , gameCode = element.data('game-code') || ued.gameCode
    , channelType = element.data('channel-type') || 'CHANNEL_PC'

  if (isAjaxing) { return }
  isAjaxing = true

  ajaxEngageCurrentGame(gameCode, channelType)
    .always(function() {
      isAjaxing = false
    })
    .done(function(userInfo) {
      var formDiaog = new EngageForm({
        userInfo: userInfo
      })

      formDiaog.render().open()
    })
    .fail(function(message) {
      return openAlert({ content: message || ERROR_MSG })
    })
}
